/** Decorative next to the existing Riverside text. Color is inherited. */
export function RiversideMark({ mode = 'day', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 100"
      width={80} height={50} fill="currentColor" aria-hidden="true" focusable="false" {...props}>
      <g data-part="landscape">
        <path data-part="kilimanjaro" d="M6 67C27 59 44 46 64 31L75 23C78 21 80 17 84 17C88 17 90 19 95 18L101 17C105 17 110 22 115 26C130 38 142 47 154 53C138 49 124 40 108 29L101 24L106 33L96 27L98 35L89 25L85 32L83 27L75 35L78 27C53 44 29 60 6 67Z"/>
        <path data-part="road-river" d="M6 67C30 61 56 59 77 60C91 61 92 65 83 69L70 74C62 78 65 81 78 84C99 89 129 89 154 85C129 94 100 95 77 92C56 89 45 84 47 78C49 73 62 70 70 67C52 64 28 65 6 67Z"/>
      </g>
      <g data-part="shuttle">
        <path fillRule="evenodd" d="M92 68L99 57C100 55 102 54 105 54H132C135 54 137 55 138 58L144 70V78H141C141 74.7 138.3 72 135 72C131.7 72 129 74.7 129 78H107C107 74.7 104.3 72 101 72C97.7 72 95 74.7 95 78H90V73C90 71 90.5 69.5 92 68ZM97 65H105V58H102L97 65ZM109 58V65H119V58H109ZM123 58V65H137L134 58H123Z"/>
        <path fillRule="evenodd" d="M105 78A4 4 0 1 1 97 78A4 4 0 1 1 105 78ZM102.5 78A1.5 1.5 0 1 0 99.5 78A1.5 1.5 0 1 0 102.5 78ZM139 78A4 4 0 1 1 131 78A4 4 0 1 1 139 78ZM136.5 78A1.5 1.5 0 1 0 133.5 78A1.5 1.5 0 1 0 136.5 78Z"/>
      </g>
      <g data-part="sun" display={mode === 'day' ? undefined : 'none'}>
        <circle cx="133" cy="23" r="10"/>
      </g>
      <g data-part="moon" display={mode === 'night' ? undefined : 'none'}>
        <path d="M137 13A10.5 10.5 0 1 0 137 33C126 31 126 15 137 13Z"/>
      </g>
    </svg>
  );
}
